import React from "react";

import cx from "./cx";

const baseClass =
  "flex min-h-[80px] w-full border bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";

type Props = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, Props>(
  ({ className, ...props }, ref) => (
    <textarea ref={ref} className={cx(baseClass, className)} {...props} />
  )
);

Textarea.displayName = "Textarea";

export { Textarea };
export default Textarea;
